export default "__VITE_ASSET__xskGz4ue__"